export const SIZE_M = "m";
